import type { Iso6391Code, LanguageOptionMeta } from '@src/domains/products/features/product-booking/types/language';

import { getIso6391LanguageMetaSync } from '@src/domains/products/features/product-booking/core/language/loadIso6391LanguageMeta';

export {
  getIso6391LanguageMetaSync,
  ISO_639_1_LANGUAGE_META,
  loadIso6391LanguageMeta,
} from '@src/domains/products/features/product-booking/core/language/loadIso6391LanguageMeta';

declare let __APP_ENV__: string;

// Normalize API values to ISO 639-1 base code (e.g. `pt-BR` → `pt`).
export const normalizeToIso6391 = (value: string): string => {
  const trimmed = value.trim().toLowerCase();

  return trimmed.split(/[-_]/)[0] ?? trimmed;
};

export const isIso6391Code = (code: string): code is Iso6391Code => {
  const meta = getIso6391LanguageMetaSync();

  return code in meta;
};

const fallbackLanguageOptionMeta = (value: string): LanguageOptionMeta => {
  const label = value.trim();

  return {
    label: label.length > 0 ? label : 'Unknown',
    flagCode: 'XX',
  };
};

export const getLanguageOptionMeta = (value: string): LanguageOptionMeta => {
  const code = normalizeToIso6391(value);
  const meta = getIso6391LanguageMetaSync();

  if (code in meta) {
    return meta[code]!;
  }

  if (__APP_ENV__ !== 'production') {
    console.warn(`[language] Unknown ISO 639-1 code: "${value}" (normalized: "${code}")`);
  }

  return fallbackLanguageOptionMeta(value);
};
